export const orderConfirmAdminDefaultTemplate = `lexical:
<p style="margin-top: 1em; text-align: center;">
  <img src="https://connectico.pl/wp-content/uploads/2020/04/cropped-connectico_logo_color_extra_small.png" style="display: block; margin-left: auto; margin-right: auto;" />
</p>

<p style="margin-top: 1em;">&nbsp;</p>

<p style="text-align: center; margin: 2em 0 1em 0;">
  <strong style="font-size: 1.4em;">Otrzymano nowe zamówienie</strong>
</p>

<p style="text-align: center; margin: 0 0 2em 0;">
  Do realizacji wpłynęło zamówienie <strong>{numer_zamowienia}</strong>.
</p>

<table style="border-collapse: collapse; border-spacing: 0; width: auto; table-layout: auto; margin-left: auto; margin-right: auto;">
	<tbody>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Numer zamówienia:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{numer_zamowienia}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Zamawiający:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{zamawiajacy_nazwa_firmy_imie_nazwisko}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>E-mail / telefon:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{zamawiajacy_email} / {zamawiajacy_nr_telefonu}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>NIP:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{zamawiajacy_nip}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Data:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{data_godzina_zamowienia}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Kwota do zapłaty:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p><strong>{zamowienie_wartosc_brutto} {waluta}</strong></p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Waluta:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{waluta}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Forma płatności:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{forma_platnosci}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Forma dostawy:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{forma_dostawy}</p></td>
		</tr>
		<tr>
			<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Adres dostawy:</strong></p></td>
			<td style="padding: 0.2em 1em; vertical-align: top;"><p>{adres_dostawy}</p></td>
		</tr>
	</tbody>
</table>

<p style="margin-top: 2em;">&nbsp;</p>

<p style="margin: 2em 0 1em 0; text-align: center;">
  <strong style="font-size: 1.4em;">Zamówione produkty</strong>
</p>

<p style="margin: 0 0 2em 0; text-align: center;">
  {tabela_zamowionych_produktow}
</p>

<table style="border-collapse: collapse; border-spacing: 0; width: 100%; max-width: 700px; table-layout: auto; margin-left: auto; margin-right: auto; border: 1px solid #d9dce1; background-color: #f9fafb;">
	<tbody>
		<tr>
			<td style="padding: 1em 1.2em; vertical-align: top;">
				<p><strong>Uwagi do zamówienia:</strong></p>
				<p>{uwagi}</p>
			</td>
		</tr>
	</tbody>
</table>

<p style="margin-top: 2em; text-align: center; color: #666;">
  Wiadomość systemowa dla zespołu obsługi zamówień.
</p>
`;
/*
Otrzymano zamówienie

Informacje o zamówieniu:

Numer zamówienia:	{numer_zamowienia}
Zamawiający:	 {zamawiajacy_nazwa_firmy_imie_nazwisko}
Adres e-mail, telefon:
{zamawiajacy_email}  {zamawiajacy_nr_telefonu}
Nip:
{zamawiajacy_nip}
Data:	{data_godzina_zamowienia}
Kwota do zapłaty:	{zamowienie_wartosc_brutto}
Forma płatności:	{forma_platnosci}
Forma dostawy:	{forma_dostawy}
Adres dostawy:	{adres_dostawy}
Waluta zamówienia:
{waluta}
Zamówione produkty:
{tabela_zamowionych_produktow}

Uwagi:
{uwagi}

 */